export interface TariffQuestion {
  id: number;
  question: string;
  tariffRate: number;
  isGood: boolean;
}

const tariffQuestions: TariffQuestion[] = [
  {
    id: 1,
    question: "30% tariff on imported boobs from Japan",
    tariffRate: 30,
    isGood: false,
  },
  {
    id: 2,
    question: "-30% tariff on premium ass NFTs",
    tariffRate: -30,
    isGood: true,
  },
  {
    id: 3,
    question: "99% tariff on Solana transactions",
    tariffRate: 99,
    isGood: true,
  },
  {
    id: 4,
    question: "50% tariff on rare Pepe memes",
    tariffRate: 50,
    isGood: false,
  },
  {
    id: 5,
    question: "10% tariff on crypto YouTubers with shocked faces",
    tariffRate: 10,
    isGood: true,
  },
  {
    id: 6,
    question: "-20% tariff on pizza paid with Bitcoin",
    tariffRate: -20,
    isGood: true,
  },
  {
    id: 7,
    question: "75% tariff on diamond hands tattoos",
    tariffRate: 75,
    isGood: true,
  },
  {
    id: 8,
    question: "40% tariff on crypto bros gym selfies",
    tariffRate: 40,
    isGood: true,
  },
  {
    id: 9,
    question: "-15% tariff on trading while taking a dump",
    tariffRate: -15,
    isGood: true,
  },
  {
    id: 10,
    question: "80% tariff on dog-themed memecoins",
    tariffRate: 80,
    isGood: false,
  },
  {
    id: 11,
    question: "25% tariff on crypto haters",
    tariffRate: 25,
    isGood: true,
  },
  {
    id: 12,
    question: "-25% tariff on metaverse strip clubs",
    tariffRate: -25,
    isGood: true,
  },
  {
    id: 13,
    question: "60% tariff on fake boobs bought with crypto",
    tariffRate: 60,
    isGood: false,
  },
  {
    id: 14,
    question: "15% tariff on rocket emoji spam",
    tariffRate: 15,
    isGood: true,
  },
  {
    id: 15,
    question: "45% tariff on memecoins named after bodily fluids",
    tariffRate: 45,
    isGood: true,
  },
  {
    id: 16,
    question: "-10% tariff on thicc blockchain validators",
    tariffRate: -10,
    isGood: true,
  },
  {
    id: 17,
    question: "70% tariff on crypto influencers shilling their bags",
    tariffRate: 70,
    isGood: true,
  },
  {
    id: 18,
    question: "20% tariff on NFTs of cartoon butts",
    tariffRate: 20,
    isGood: false,
  },
  {
    id: 19,
    question: "-5% tariff on crypto memes that make you snort coffee",
    tariffRate: -5,
    isGood: true,
  },
  {
    id: 20,
    question: "90% tariff on calling yourself Satoshi Nakamoto",
    tariffRate: 90,
    isGood: true,
  },
  {
    id: 21,
    question: "55% tariff on boomer investors who still use fax machines",
    tariffRate: 55,
    isGood: true,
  },
  {
    id: 22,
    question: "-40% tariff on trading in your underwear",
    tariffRate: -40,
    isGood: true,
  },
  {
    id: 23,
    question: "85% tariff on dating apps for crypto enthusiasts",
    tariffRate: 85,
    isGood: false,
  },
  {
    id: 24,
    question: "35% tariff on NFTs of your ex's nudes",
    tariffRate: 35,
    isGood: true,
  },
  {
    id: 25,
    question: "-18% tariff on bikini NFT collections",
    tariffRate: -18,
    isGood: true,
  },
  {
    id: 26,
    question: "65% tariff on Solana outage memes",
    tariffRate: 65,
    isGood: false,
  },
  {
    id: 27,
    question: "22% tariff on buying crypto instead of paying rent",
    tariffRate: 22,
    isGood: false,
  },
  {
    id: 28,
    question: "-35% tariff on DeFi projects with suggestive names",
    tariffRate: -35,
    isGood: true,
  },
  {
    id: 29,
    question: "78% tariff on celebrities launching their own memecoins",
    tariffRate: 78,
    isGood: true,
  },
  {
    id: 30,
    question: "12% tariff on metaverse fashion shows",
    tariffRate: 12,
    isGood: false,
  },
  {
    id: 31,
    question: "-22% tariff on sexy blockchain developer calendars",
    tariffRate: -22,
    isGood: true,
  },
  {
    id: 32,
    question: "66% tariff on buying lambos before paying taxes",
    tariffRate: 66,
    isGood: true,
  },
  {
    id: 33,
    question: "28% tariff on blockchain-powered dating verification",
    tariffRate: 28,
    isGood: false,
  },
  {
    id: 34,
    question: "-13% tariff on saying HODL during intimate moments",
    tariffRate: -13,
    isGood: true,
  },
  {
    id: 35,
    question: "95% tariff on crypto ATMs in strip clubs",
    tariffRate: 95,
    isGood: false,
  },
  {
    id: 36,
    question: "17% tariff on using crypto terms as baby names",
    tariffRate: 17,
    isGood: true,
  },
  {
    id: 37,
    question: "-27% tariff on web3 booty streaming platforms",
    tariffRate: -27,
    isGood: true,
  },
  {
    id: 38,
    question: "72% tariff on creating memecoins based on your crush",
    tariffRate: 72,
    isGood: true,
  },
  {
    id: 39,
    question: "33% tariff on blockchain wedding registries",
    tariffRate: 33,
    isGood: false,
  },
  {
    id: 40,
    question: "-8% tariff on custom crypto hardware wallets shaped like body parts",
    tariffRate: -8,
    isGood: true,
  },
  {
    id: 41,
    question: "82% tariff on dating someone just for their crypto portfolio",
    tariffRate: 82,
    isGood: true,
  },
  {
    id: 42,
    question: "14% tariff on staking while sleeping",
    tariffRate: 14,
    isGood: false,
  },
  {
    id: 43,
    question: "-32% tariff on blockchain-based adult content creation",
    tariffRate: -32,
    isGood: true,
  },
  {
    id: 44,
    question: "58% tariff on AI-generated sexy NFT avatars",
    tariffRate: 58,
    isGood: false,
  },
  {
    id: 45,
    question: "26% tariff on crypto mining under your bed",
    tariffRate: 26,
    isGood: false,
  },
  {
    id: 46,
    question: "-17% tariff on meme NFTs featuring butts and rockets",
    tariffRate: -17,
    isGood: true,
  },
  {
    id: 47,
    question: "69% tariff on NFT breeding platforms",
    tariffRate: 69,
    isGood: true,
  },
  {
    id: 48,
    question: "24% tariff on blockchain body measurement verification",
    tariffRate: 24,
    isGood: false,
  },
  {
    id: 49,
    question: "-9% tariff on decentralized hookup apps",
    tariffRate: -9,
    isGood: true,
  },
  {
    id: 50,
    question: "77% tariff on checking portfolio prices during sex",
    tariffRate: 77,
    isGood: true,
  },
];

export function getRandomQuestion(): TariffQuestion {
  const randomIndex = Math.floor(Math.random() * tariffQuestions.length);
  return tariffQuestions[randomIndex];
}

export default tariffQuestions; 